<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="text-primary m-0">
      {{ $t("app.modules.complaints.buttons.add") }}
    </h4>
     <div class="col-12">
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewItem)">
        <div class="row">
          <div :class="sizes">
            <div style="margin-bottom: -13px;" class=" form-group has-label">
              <label for="">{{ $t("app.modules.complaints.headers.product") }}</label>
            </div>
            <ValidationProvider
              name="requiredFase"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <el-select
                class="d-block"
                size="large"
                @change="cambiarDato"
                filterable
                :placeholder="
                  'Elige la partida'
                "
                v-model="PedidoInfo.faseEntrega"
              >
                <el-option
                  :hasSuccess="passed"
                  v-for="partida in detallesPedido"
                  :value="partida.idDetallePedido"
                  :label="partida.descripcionProducto
                  "
                  :key="partida.idDetallePedido"
                >
                </el-option>
              </el-select>
              <div
                v-if="failed"
                class="text-danger invalid-feedback"
                style="display: block;"
              >
                {{ required_text }}
              </div>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
            <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.product')"
              v-model="PedidoInfo.producto"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.batch')"
              v-model="PedidoInfo.lote"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.purchase_order')"
              v-model="PedidoInfo.odc"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.product_description')"
              v-model="PedidoInfo.descripcionProducto"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              disabled
              type="text"
              :label="$t('app.modules.complaints.headers.order_numbre')"
              v-model="PedidoInfo.pedido"
            >
            </fg-input>
          </div>
          <div :class="sizes">
          <div class="form-group has-label">
            {{$t("app.modules.complaints.headers.description")}}
          </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              name="minLength"
              :placeholder="$t('app.modules.complaints.headers.description')"
              v-model="PedidoInfo.descripcion"
            >
            </el-input>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
          <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                multiple
                accept="image/*, .pdf, .docx, .doc, .pptx"
                :file-list="fileList"
                :limit="5"

                :auto-upload="false"
                :on-change="handleFile"
                :on-remove="handleFile">
                <n-button size="small" type="primary">{{ $t("app.upload.select_file") }}</n-button>
                <div slot="tip" class="el-upload__tip">{{ $t("app.upload.upload_formats") }}</div>
              </el-upload>

          </div>
        </div>
        <el-divider></el-divider>
        <div class="row">
          <div :class="sizes">
              <span><b>{{ $t("app.modules.complaints.headers.claimant_name") + ": "}}</b></span>
              <br>
              <span>{{ item.nombre }}</span>
          </div>
          <div :class="sizes">
              <span><b>{{ $t("app.modules.complaints.headers.telephone") + ": "}}</b></span>
              <br>
              <span>{{ item.telefono }}</span>
          </div>
          <div :class="sizes">
              <span><b>{{ $t("app.modules.complaints.headers.emai") + ": "}}</b></span>
              <br>
              <span>{{ item.email }}</span>
          </div>
      </div>
      <el-divider></el-divider>
        <div
          slot="footer"

          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd">{{
              $t("app.buttons.close")
            }}</n-button>
          <n-button native-type="submit" type="primary">{{
              $t("app.modules.complaints.buttons.send")
            }}</n-button>
        </div>
      </form>
    </ValidationObserver>
 </div>
  </modal>
</template>

<script>

import { mapState } from "vuex";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

export default {
  components: {
  },
  computed: {
    ...mapState(["user"])
  },
  data(){
    return{
      file_formats: "image/png, image/jpeg, image/gif, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.presentationml.presentation",
      sizes: "col-md-6 col-sm-12",
      required_text: this.$t("app.general.required"),
      detallesPedido: [],
      PedidoInfo: [],
      datos_extras: {
        idUsuarioVendedor: 0,
        contactoCliente_idContacto: 0,
        telefono :""
      },
      selectIncompleto: false,
      enableSendButton: false,
      fileList: [],
      item: {
        idReclamacion:0,
        producto: '',
        lote: '',
        factura: '',
        odc: '',
        pedido: '',
        descripcion: '',
        UsuarioVendedor: 0,
        telefono: ''
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modals: {
        classic: false,
        notice: false,
        mini: false
      },
    }
  },
  created(){ },
  async mounted(){
    EventBus.$on("show-add-new-claim", async datosProducto => {
      try{
      this.$refs.upload.clearFiles();
      }catch(Exception){

      }
      this.item = new Object({
        idReclamacion:0,
        producto: datosProducto.idProducto,
        odc: datosProducto.ordenCompraCliente,
        pedido: datosProducto.idPedido,
        descripcion: datosProducto.descripcion,
        nombre: !!this.user.nombre ? this.user.nombre : "N/A",
        email: !!this.user.correo ? this.user.correo : "",
        telefono: !!this.user.telefono ? this.user.telefono : "S/N"
      });
      this.PedidoInfo = new Object({
        odc: datosProducto.ordenCompraCliente,
        pedido: datosProducto.idPedido,
        evidencias: [],
        producto : "",
        descripcionProducto: "",
        descripcion: "",
        lote: ""
      });
      await this.initReclamaAdd();
      this.modals.classic = true;
    });
  },
  methods: {
    cambiarDato(value){
      var dato = this.detallesPedido.find(element => element.idDetallePedido == value)
      if(dato){
        this.PedidoInfo.producto = dato.idProducto;
        this.PedidoInfo.descripcionProducto = dato.descripcionProducto;
      }
    },
    async getDetallesPedidoReclam() {
      var paramDetall = {
        Id: this.item.pedido,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0
      };
      await this.$http.post(route("Pedidos/getPedidoDetalleWeb"), paramDetall).then(
        response => {
          if (response.body.code === 200) {
               this.detallesPedido = response.body.detalles;
          } else {
           this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    async initReclamaAdd(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getClientUser();
      await this.getDetallesPedidoReclam();
      await this.getUserVendorByClienIdUser();
      this.$swal.close();
    },
    async getClientUser() {
      const params = {
        Id: this.item.idPedido,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
      };

      await this.$http.post(route("Clientes/getContactosByClienteUserId"), params).then(
        response => {
          if (response.body.code === 200) {
            console.log(response.body.contactos);
            if(response.body.contactos.length > 0){
                console.log(response.body.contactos[0])
                this.datos_extras.contactoCliente_idContacto = response.body.contactos[0].idContacto;
                this.datos_extras.telefono = response.body.contactos[0].telefono;
            }
            else{
              this.notifyMessage("danger", this.$t("app.modules.complaints.messages.client_error"));
            }
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    async getUserVendorByClienIdUser() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.post(route("Usuarios/getUsuariosVendorByClientUserId"), params).then(
        response => {
          if (response.body.code === 200) {
            console.log(response.body.usuarios);
            if(response.body.usuarios.length > 0){
                this.datos_extras.idUsuarioVendedor = response.body.usuarios[0].idUsuario;

            }else{
              this.notifyMessage("danger", this.$t("app.modules.complaints.messages.vendor_error"));
            }
          } else {
            console.log(response.body);
           this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    cancelAdd() {
      this.$refs.upload.clearFiles();
      this.PedidoInfo = new Object({
        odc: this.item.ordenCompraCliente,
        pedido: this.item.pedido,
        evidencias: [],
        producto : "",
        descripcionProducto: "",
        descripcion: "",
        lote: ""
      });
      this.modals.classic = false;
    },
    async submitNewItem() {
        if(this.datos_extras.contactoCliente_idContacto < 1){
            this.notifyMessage("danger", this.$t("app.modules.complaints.messages.client_error"));
        } else if(this.datos_extras.usuarioVendor < 1){
               this.notifyMessage("danger", this.$t("app.modules.complaints.messages.vendor_error"));
        } else {
          this.$swal.fire({
            title: this.$t("app.promps.wait"),
            html:
              '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
            showConfirmButton: false
          });

          try {
            if(!!!this.PedidoInfo.descripcion) throw new Error(this.$t('app.modules.complaints.errors.no_description'));

            await this.addNewRow();
          }
          catch (e){
            this.notifyMessage('danger', e.message);
          }
          finally
          {
            this.$swal.close();
          }
      }
    },
    async addNewRow() {
      let formData = new FormData();
      let obj = {
        //idReclamacion: this.item.idReclamacion,
        producto: this.PedidoInfo.producto,
        lote: this.PedidoInfo.lote,
        factura: this.PedidoInfo.factura,
        odc: this.PedidoInfo.odc,
        pedido: this.PedidoInfo.pedido,
        descripcion: this.PedidoInfo.descripcion,
        UsuarioVendedor: this.datos_extras.idUsuarioVendedor,
        ContactoCliente_idContacto: this.datos_extras.contactoCliente_idContacto
      }

      let data = new FormData();
      data.append("param", JSON.stringify(obj));

      if(this.PedidoInfo.evidencias.length > 0){
        for (const evidencia of this.PedidoInfo.evidencias) {
          data.append("evidencias", evidencia);
        }
      }
      for(var item of formData.values()){
        console.log(item)
      }
      await this.$http
        .post(route("Reclamaciones/postReclamacionAsClient"), data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
        )
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.modules.complaints.messages.send_claim"));
              // Limpia formulario
              this.$refs.upload.clearFiles();
              this.PedidoInfo = new Object({
                odc: this.item.ordenCompraCliente,
                pedido: this.item.pedido,
                evidencias: [],
                producto : "",
                descripcionProducto: "",
                descripcion: "",
                lote: ""
              });
              this.$router.push({
                name: "Reclamaciones"
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    handleFile(file, fileList) {
      var correctFormats = true;
      this.PedidoInfo.evidencias = [];
      for(let f of fileList){
        let index = fileList.indexOf(f);
        if(f.raw !== undefined && f.raw.type !== ""){
          if(this.file_formats.includes(f.raw.type)){
            this.PedidoInfo.evidencias.push(f.raw);
          }else{
            fileList.splice(index, 1);
            correctFormats = false;
          }
        }else{
           fileList.splice(index, 1);
           correctFormats = false;
        }
      }
      if(!correctFormats){
        this.notifyMessage("warning", this.$t("app.upload.upload_formats"));
      }
    },
  }
}
</script>


